import { jsx as a, jsxs as T, Fragment as we } from "react/jsx-runtime";
import { fpds as re } from "@fcamna/shared-component-foundations";
import { c as S } from "./index-65016bfa.mjs";
import K, { useRef as W, useEffect as q, useContext as Ve, createContext as je, useState as F, useMemo as _e, useCallback as ge } from "react";
import { createPortal as Je } from "react-dom";
import v, { css as y } from "styled-components";
import { u as Qe } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { u as Ze } from "./useWindowSize-88e90e04.mjs";
import { Checkbox as $e, CheckboxStateValues as ve } from "./checkbox.js";
import { Icon as Ge } from "./icon.js";
import { Ellipses as Xe } from "./menu.js";
import { TextInput as Oe } from "./textInput.js";
import { u as Z } from "./useAccessibilityProps-2f24cf29.mjs";
import { g as ye } from "./getElementPosition-a8642645.mjs";
import { u as Re } from "./uniqueId-321287e8.mjs";
import { Radio as et } from "./radio.js";
const tt = v.li`
  &.DropdownBaseItem__List-wrapper {
    ${({
  theme: {
    components: { dropdownMenuBase: r }
  }
}) => y(r.ListWrapper)};
  }
`, rt = v.span`
  &.DropdownBaseItem__Item-text {
    ${({
  theme: {
    components: { dropdownMenuBase: r }
  }
}) => y(r.ItemText)};
  }
`, De = v.div`
  &.DropdownBaseItem__Leading-element {
    ${({
  theme: {
    components: { dropdownMenuBase: r }
  }
}) => y(r.LeadingElementWrapper)};
  }
`, at = v.div`
  &.DropdownBaseItem__Trailing-element {
    ${({
  theme: {
    components: { dropdownMenuBase: r }
  }
}) => y(r.TrailingElementWrapper)};
  }
`, J = K.memo(({ value: r, disable: s }) => {
  const c = W(null);
  return q(() => {
    var b;
    c != null && c.current && ((b = c.current) == null || b.querySelector('input[type="checkbox"]').setAttribute("tabindex", "-1"));
  }, []), /* @__PURE__ */ a(
    "span",
    {
      className: "check-wrapper",
      "aria-hidden": "true",
      tabIndex: -1,
      style: { pointerEvents: "none" },
      ref: c,
      children: /* @__PURE__ */ a(
        $e,
        {
          label: "",
          checkboxValue: r,
          isDisabled: s
        }
      )
    }
  );
}), Q = K.memo(({ value: r, disable: s }) => {
  const c = W(null);
  return q(() => {
    var b, d;
    c != null && c.current && ((b = c.current) == null || b.querySelector('input[type="radio"]').setAttribute("tabindex", "-1"), (d = c.current) == null || d.querySelector("label.RadioButton-wrapper").setAttribute("tabindex", "-1"));
  }, []), /* @__PURE__ */ a(
    "span",
    {
      className: "radio-section",
      ref: c,
      children: /* @__PURE__ */ a(
        et,
        {
          checked: r,
          label: "",
          value: "",
          disabled: s
        }
      )
    }
  );
}), lt = {
  radio: {
    default: [
      /* @__PURE__ */ a(
        Q,
        {
          value: !1,
          disable: !1
        },
        "radio_unchecked"
      ),
      /* @__PURE__ */ a(
        Q,
        {
          value: !0,
          disable: !1
        },
        "radio_checked"
      )
    ],
    disabled: [
      /* @__PURE__ */ a(
        Q,
        {
          value: !1,
          disable: !0
        },
        "radio_unchecked_disabled"
      ),
      /* @__PURE__ */ a(
        Q,
        {
          value: !0,
          disable: !0
        },
        "radio_checked_disabled"
      )
    ]
  },
  multiple: {
    default: [
      /* @__PURE__ */ a(
        J,
        {
          value: 0,
          disable: !1
        },
        "box_unchecked"
      ),
      /* @__PURE__ */ a(
        J,
        {
          value: 2,
          disable: !1
        },
        "box_checked"
      )
    ],
    disabled: [
      /* @__PURE__ */ a(
        J,
        {
          value: 0,
          disable: !0
        },
        "box_unchecked_disabled"
      ),
      /* @__PURE__ */ a(
        J,
        {
          value: 2,
          disable: !0
        },
        "box_checked_disabled"
      )
    ]
  }
}, ot = ({
  label: r,
  value: s,
  id: c = s,
  description: b,
  trailingElement: d,
  leadingElement: B,
  disabled: u = !1,
  className: w,
  isSelected: U = !1,
  ...G
}) => {
  const { type: N, handleSelect: D } = Ve(xe), X = Z("option", {
    tabIndex: -1,
    ariaDisabled: u,
    ariaSelected: U,
    ariaLabel: r
  });
  return /* @__PURE__ */ a(
    tt,
    {
      id: c,
      disabled: u,
      "data-value": s,
      onKeyUp: (A) => {
        (A.code === "Space" || A.code === "Enter") && (A.preventDefault(), A.stopPropagation(), !u && D && D(A, s));
      },
      className: S([
        "DropdownBaseItem__List-wrapper",
        "list-item",
        { active: N === "default" && U && !u },
        w,
        `_${le(s)}`
      ]),
      ...X,
      ...G,
      onClick: (A) => !u && D(A, s),
      children: /* @__PURE__ */ T(
        rt,
        {
          tabIndex: -1,
          disabled: u,
          className: S(["DropdownBaseItem__Item-text", { "DropdownBaseItem__Item-text--disable": u }]),
          children: [
            N === "default" ? B && /* @__PURE__ */ a(
              De,
              {
                disabled: u,
                className: S([
                  "DropdownBaseItem__Leading-element",
                  { "DropdownBaseItem__Leading-element--disable": u },
                  `DropdownBaseItem__Leading-element--${N}`
                ]),
                children: B
              }
            ) : /* @__PURE__ */ a(
              De,
              {
                disabled: u,
                className: S([
                  "DropdownBaseItem__Leading-element",
                  { "DropdownBaseItem__Leading-element--disable": u },
                  `DropdownBaseItem__Leading-element--${N}`
                ]),
                children: lt[N][u ? "disabled" : "default"][U ? 1 : 0]
              }
            ),
            /* @__PURE__ */ T("div", { children: [
              /* @__PURE__ */ a("div", { className: "title", children: r }),
              b
            ] }),
            d && /* @__PURE__ */ a(
              at,
              {
                disabled: u,
                className: S(["DropdownBaseItem__Trailing-element", { "DropdownBaseItem__Trailing-element--disable": u }]),
                children: d
              }
            )
          ]
        }
      )
    }
  );
}, Ee = K.memo(
  ot,
  (r, s) => r.value === s.value && r.id === s.id && r.isSelected === s.isSelected && r.className === s.className && r.disabled === s.disabled
), nt = "Escape", st = v.div`
  &.DropdownBase__wrapper {
    ${({
  theme: {
    components: { dropdownMenuBase: r }
  }
}) => y(r.MainWrapper)};
  }
`, it = v.div`
  &.DropdownBase__trigger-wrapper {
    ${({
  theme: {
    components: { dropdownMenuBase: r }
  }
}) => y(r.TriggerWrapper)};
  }
`, ct = v.div`
  @keyframes menuOpen {
    0% {
      transform: scaleY(0);
    }
    100% {
      transform: scaleY(1);
    }
  }
  @keyframes menuClose {
    0% {
      transform: scaleY(1);
      display: block;
    }
    99% {
      transform: scaleY(0);
      display: block;
    }
    100% {
      transform: scaleY(0);
      display: none;
    }
  }
  &.DropdownBase__content-wrapper {
    ${({
  theme: {
    components: { dropdownMenuBase: r }
  }
}) => y(r.ContentWrapper)};
  }
`, dt = v.ul`
  &.DropdownBase__Content-list {
    ${({
  theme: {
    components: { dropdownMenuBase: r }
  },
  $active: s,
  $maxItems: c,
  $hiddenClasses: b
}) => {
  const d = b.map((B) => `_${le(B)}`).join(", li.");
  return y(r.ContentList, {
    maxHeight: `${c * 40}px`,
    [`li.active.${s}`]: {
      backgroundColor: re.semantic.color.fill.primarySubtlest,
      "div[type]": {
        "span[role='status']": {
          color: re.semantic.color.text.onColor
        }
      },
      "*": {
        color: re.semantic.color.text.primaryStrongest
      }
    },
    [`li.${d}`]: {
      display: "block"
    }
  });
}};
  }
`, ae = v.div`
  ${({
  theme: {
    components: { dropdownMenuBase: r }
  }
}) => y(r.Divider)};
`, ut = v.div`
  ${({
  theme: {
    components: { dropdownMenuBase: r }
  }
}) => y(r.Title)};
`, pt = v.div`
  ${({
  theme: {
    components: { dropdownMenuBase: r }
  }
}) => y(r.Control)};
`, mt = v.div`
  &.DropdownBase-local-search {
    ${({
  theme: {
    components: { dropdownMenuBase: r }
  }
}) => y(r.LocalSearchWrapper)};
  }
`, ft = v.div`
  &.DropdownBase__select-all-wrapper {
    ${({
  theme: {
    components: { dropdownMenuBase: r }
  }
}) => y(r.SelectAllWrapper)};
  }
`, ht = v.div`
  ${({
  theme: {
    components: { dropdownMenuBase: r }
  }
}) => y(r.NoResult)};
`, le = (r) => r.replace(/[^a-zA-Z0-9]/g, "_"), xe = je({}), Ce = (r, s, c) => {
  let b = r.trimStart();
  return b = b.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), c.length > 0 ? s.filter((d) => !c.includes(d.value)).map((d) => d.value) : s.filter((d) => `${d.label}${d.value}`.search(new RegExp(b, "i")) >= 0).map((d) => d.value);
}, ke = (r, s) => s ? r === "up_auto" ? "up_left" : "down_left" : r, Y = ({
  children: r,
  uniqueIdentifier: s,
  handleMenuOpen: c,
  onChange: b,
  type: d = "default",
  menuHeader: B = "default",
  isDisabled: u = !1,
  menuDirection: w = "down_left",
  onBlur: U,
  closeOnSelect: G,
  maxItems: N = 8,
  menuOpen: D,
  className: X,
  noResultText: A = "No results found",
  hiddenItems: z = [],
  exceedOverflow: I = !1,
  accessibilityOptions: Se = {},
  ...Be
}) => {
  const Ae = Qe({ label: "Dropdown Menu Base" }), [V, O] = F(-1), x = W(null), p = W([]);
  p.current.callbacks = {
    onChange: b,
    onBlur: U
  };
  const Ie = W(Re("dd")), _ = s || Ie.current, { menuIcon: Le } = Se, Ne = Z("button", {
    ariaLabel: "dropdown menu",
    ariaExpanded: D ? "true" : "false",
    ariaControls: `list-${_}`,
    ...Le
  }), [M, oe] = F(""), [H, ne] = F(["menu-header"]), [R, Te] = F(!1), [We, se] = F({}), g = W(null), f = W(null), { width: Ue, height: Me } = Ze(), Pe = Z("region", {
    ariaHidden: !D
  }), qe = Z("listbox", {
    ariaMultiselectable: d === "multiple",
    ariaLabel: "unorder-list"
  }), ie = /* @__PURE__ */ a(
    Xe,
    {
      id: `control-${_}`,
      ...Ne
    }
  ), Ke = _e(() => {
    let e = !0;
    p.current.list = [], p.current.currentEle = !0, p.current.controlElement = ie;
    const t = K.Children.map(r, (h) => {
      if (h && K.isValidElement(h))
        if (h.type === Y.Control)
          p.current.controlElement = h;
        else {
          if (h.type === Ee) {
            const m = h.props;
            p.current.list.push({
              label: m.label,
              value: m.value,
              selected: m.isSelected,
              disabled: !!m.disabled
            }), m.isSelected || (e = !1);
          }
          return h;
        }
      return null;
    });
    return Te(e), ne(["menu-header", ...Ce(M, p.current.list, z)]), t;
  }, [r]);
  q(() => {
    ne(["menu-header", ...Ce(M, p.current.list, z)]);
  }, [M]), q(() => {
    if (x != null && x.current) {
      const e = document.getElementById(`list-${_}`), t = document.getElementById(`list-container-${_}`);
      e && (e == null ? void 0 : e.scrollHeight) > (e == null ? void 0 : e.clientHeight) ? t == null || t.classList.add("scroll") : t == null || t.classList.remove("scroll");
    }
  }, [r, _]);
  const j = ge(
    (e, t, h = !1) => {
      var $, E, i;
      const { onChange: m, onBlur: k } = p.current.callbacks;
      if (!((($ = e == null ? void 0 : e.target) == null ? void 0 : $.tagName) === "INPUT" && ((E = e == null ? void 0 : e.target) == null ? void 0 : E.type) !== "radio" && ((i = e == null ? void 0 : e.target) == null ? void 0 : i.ariaLabel) !== "Select All"))
        if (d === "multiple") {
          const n = [];
          h ? p.current.list.forEach((l) => {
            t && n.push({
              label: l.label,
              value: l.value,
              disabled: l.disabled
            });
          }) : p.current.list.forEach((l) => {
            l.selected ? l.value !== t && n.push({
              label: l.label,
              value: l.value,
              disabled: l.disabled
            }) : l.value === t && n.push({
              label: l.label,
              value: l.value,
              disabled: l.disabled
            });
          }), m && (e.target.value = JSON.stringify(n), m(e, n)), k && k(e);
        } else {
          const n = [];
          p.current.list.forEach((l) => {
            l.value === t && n.push({ label: l.label, value: l.value });
          }), m && (e.target.value = JSON.stringify(n == null ? void 0 : n[0]), m(e, n == null ? void 0 : n[0])), k && k(e), G && P();
        }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  ), P = K.useCallback(() => {
    var e, t;
    c && c(!1), x.current && p.current.currentEle && (p.current.currentEle = !1, (t = (e = x.current) == null ? void 0 : e.querySelector(`#control-${s}`)) == null || t.focus());
  }, []), He = _e(() => ({ type: d, handleSelect: j }), [j, d]), ce = (e) => {
    var E, i, n, l, L, ue, pe, me, fe, he, be;
    let t = Array.from(((E = f.current) == null ? void 0 : E.querySelectorAll("li.list-item")) || []);
    const h = (n = (i = f.current) == null ? void 0 : i.querySelectorAll("li.list-item:not([disabled])")) == null ? void 0 : n.length, m = V === -1 ? 0 : V;
    if (B === "local_search" && z.length === 0) {
      const C = (l = f == null ? void 0 : f.current) == null ? void 0 : l.querySelector(`.list-item #local-search-${_}`);
      C && C.setAttribute("data-value", "menu-header"), t = [C, ...t];
    } else if (B === "select_all") {
      const C = (L = f == null ? void 0 : f.current) == null ? void 0 : L.querySelector(`.list-item#select-all-${_} input[type="checkbox"]`);
      C && C.setAttribute("data-value", "menu-header"), t = [C, ...t];
    }
    const k = () => {
      var C;
      if (e == null || e.preventDefault(), e == null || e.stopPropagation(), h && t) {
        let o = V - 1;
        for (o < 0 && (o = t.length - 1), t[o] || (o = o - 1); (t[o].ariaDisabled !== "false" || !H.includes(t[o].getAttribute("data-value"))) && (o = o - 1, o < 0 && (o = t.length - 1), m !== o); )
          ;
        (C = t[o]) == null || C.focus(), O(o);
      }
      return !1;
    }, $ = () => {
      var C;
      if (e == null || e.preventDefault(), e == null || e.stopPropagation(), h && t) {
        let o = V + 1;
        for (o >= t.length && (o = 0), t[o] || (o = o + 1); (t[o].ariaDisabled !== "false" || !H.includes(t[o].getAttribute("data-value"))) && (o = o + 1, o >= t.length && (o = 0), m !== o); )
          ;
        (C = t[o]) == null || C.focus(), O(o);
      }
      return !1;
    };
    switch (e.key) {
      case nt:
        (pe = (ue = x == null ? void 0 : x.current) == null ? void 0 : ue.querySelector(`#control-${_}`)) == null || pe.focus(), D && (e == null || e.stopPropagation(), e == null || e.preventDefault()), P();
        break;
      case "Enter":
        if (((me = e == null ? void 0 : e.target) == null ? void 0 : me.tagName) === "BUTTON" || ((fe = e == null ? void 0 : e.target) == null ? void 0 : fe.ariaLabel) === "Select All")
          return;
        ee();
        break;
      case " ":
        if (((he = e == null ? void 0 : e.target) == null ? void 0 : he.tagName) === "BUTTON" || ((be = e == null ? void 0 : e.target) == null ? void 0 : be.ariaLabel) === "Select All")
          return;
        ee();
        break;
      case "ArrowUp":
        k();
        break;
      case "ArrowDown":
        $();
        break;
      default:
        return;
    }
  }, Fe = () => {
    if (d === "multiple")
      return "";
    for (let e = 0; e < p.current.list.length; e++) {
      const t = p.current.list[e];
      if (t.selected && !t.disable)
        return `_${le(t.value)}`;
    }
  }, ee = () => {
    D ? P() : Ye();
  }, Ye = () => {
    O(-1), oe(""), p.current.currentEle = !0, c && c(!0);
  };
  q(() => {
    const e = (t) => {
      x.current && !x.current.contains(t.target) && D && (p.current.currentEle = !1, P());
    };
    return window.addEventListener("click", e), window.addEventListener("keyup", e), () => {
      window.removeEventListener("click", e), window.removeEventListener("keyup", e);
    };
  }, [D, P]);
  const te = ge(
    (e, t, h = !1) => {
      const { innerWidth: m, innerHeight: k } = window, $ = ["auto", "up_auto", "down_auto"].includes(w), E = ke(w, $);
      let i = ye(g, f, E, "dropdown");
      if ($) {
        const n = parseFloat(i.top), l = parseFloat(i.left);
        w === "auto" && (n < 0 ? i = {
          ...i,
          top: `${8 + ((t == null ? void 0 : t.bottom) || e.height + ((t == null ? void 0 : t.height) ?? 40))}px`,
          transformOrigin: "top center"
        } : n + e.height > k && (i = {
          ...i,
          top: `${(t != null && t.top ? t == null ? void 0 : t.top : n - 48) - e.height - (h ? 8 : 24)}px`,
          transformOrigin: "bottom center"
        }));
        let L = i.transformOrigin;
        w === "up_auto" ? L = "bottom center" : w === "down_auto" && (L = "top center"), l < 0 ? i = {
          ...i,
          left: "8px",
          transformOrigin: L
        } : l + e.width > m ? i = {
          ...i,
          left: `${m - e.width - 8}px`,
          transformOrigin: L
        } : i = {
          ...i,
          transformOrigin: L
        };
      }
      se(i);
    },
    [w]
  );
  q(() => {
    if (D && I) {
      const e = ["auto", "up_auto", "down_auto"].includes(w), t = ke(w, e);
      se(ye(g, f, t, "dropdown"));
      const h = () => {
        var i, n, l;
        const $ = (i = g.current) == null ? void 0 : i.querySelector('[data-trigger="true"]'), E = $ ? $.getBoundingClientRect() : (n = g == null ? void 0 : g.current) == null ? void 0 : n.getBoundingClientRect();
        te((l = f == null ? void 0 : f.current) == null ? void 0 : l.getBoundingClientRect(), E, !0);
      };
      window.addEventListener("scroll", h, !0);
      const m = ($) => {
        window.requestAnimationFrame(() => {
          var n, l;
          const E = (n = g.current) == null ? void 0 : n.querySelector('[data-trigger="true"]'), i = E ? E.getBoundingClientRect() : (l = g == null ? void 0 : g.current) == null ? void 0 : l.getBoundingClientRect();
          te($[0].contentRect, i);
        });
      }, k = new ResizeObserver(m);
      return k.observe(f == null ? void 0 : f.current), k.observe(g == null ? void 0 : g.current), () => {
        window.removeEventListener("scroll", h, !0), k.disconnect();
      };
    }
  }, [D, w, I, Ue, Me, te]);
  const ze = () => {
    if (B === "local_search" && z.length === 0)
      return /* @__PURE__ */ T(we, { children: [
        /* @__PURE__ */ a(mt, { className: S(["DropdownBase-local-search", "list-item"]), children: /* @__PURE__ */ a(
          Oe,
          {
            labelProp: {
              label: ""
            },
            id: `local-search-${_}`,
            textSize: "medium",
            placeholder: "Search...",
            value: M,
            startAdornment: /* @__PURE__ */ a(Ge, { name: "search" }),
            onChange: (e) => {
              oe(e.currentTarget.value);
            },
            onKeyUp: (e) => {
              (e == null ? void 0 : e.key) !== "Escape" && (e == null ? void 0 : e.key) !== "ArrowUp" && (e == null ? void 0 : e.key) !== "ArrowDown" && (e == null || e.preventDefault(), e == null || e.stopPropagation());
            },
            accessibilityOptions: {
              ariaDisabled: !1
            }
          }
        ) }),
        /* @__PURE__ */ a(ae, {})
      ] });
    if (d === "multiple" && B === "select_all")
      return /* @__PURE__ */ T(we, { children: [
        /* @__PURE__ */ a(
          ft,
          {
            className: S(["DropdownBase__select-all-wrapper", "list-item"]),
            "aria-label": "Select All",
            onBlur: U,
            onClick: (e) => {
              e == null || e.preventDefault(), e == null || e.stopPropagation(), j(e, R ? "" : " ", !0);
            },
            onKeyDown: (e) => {
              ((e == null ? void 0 : e.code) === "Space" || (e == null ? void 0 : e.code) === "Enter") && (j(e, R ? "" : " ", !0), e == null || e.preventDefault(), e == null || e.stopPropagation());
            },
            id: `select-all-${_}`,
            children: /* @__PURE__ */ a("span", { style: { pointerEvents: "none" }, children: /* @__PURE__ */ a(
              $e,
              {
                tabIndex: -1,
                id: "select-all",
                label: "Select All",
                "aria-disabled": !1,
                checkboxValue: R ? ve.CHECKED : ve.UNCHECKED
              },
              "select-all"
            ) })
          },
          `select-all-${_}`
        ),
        /* @__PURE__ */ a(ae, {})
      ] });
  }, de = () => {
    let e = w;
    return I || (w === "auto" || w === "down_auto" ? e = "down_left" : w === "up_auto" && (e = "up_left")), /* @__PURE__ */ T(
      ct,
      {
        id: `content-${_}`,
        onMouseDown: I ? (t) => {
          t.stopPropagation();
        } : void 0,
        onClick: I ? (t) => {
          t.stopPropagation();
        } : void 0,
        ...Pe,
        onKeyUp: (t) => {
          u || ce(t);
        },
        onKeyDown: (t) => {
          if (t.key === "ArrowUp" || t.key === "ArrowDown")
            return t == null || t.preventDefault(), t == null || t.stopPropagation(), !1;
          I && t.code === "Tab" && (t.preventDefault(), t.stopPropagation(), P());
        },
        className: S([
          "DropdownBase__content-wrapper",
          `${I && "DropdownBase__content-wrapper--exceed"}`,
          { "DropdownBase__content-wrapper--menu-open": D },
          `DropdownBase__content-wrapper-direction--${e}`
        ]),
        ref: f,
        style: I ? We : {},
        children: [
          ze(),
          /* @__PURE__ */ a(
            "div",
            {
              id: `list-container-${_}`,
              onKeyDown: (t) => {
                t.code === "Space" && (t.preventDefault(), t.stopPropagation());
              },
              children: /* @__PURE__ */ T(
                dt,
                {
                  $hiddenClasses: H,
                  $searchText: M.trim().length > 0,
                  $active: Fe(),
                  $maxItems: N,
                  id: `list-${_}`,
                  className: S([
                    "DropdownBase__Content-list",
                    (M.trim().length > 0 || H.length <= 1) && "DropdownBase__Content-list-searchable"
                  ]),
                  ...qe,
                  children: [
                    Ke,
                    H.length === 1 && /* @__PURE__ */ a(ht, { role: "option", className: "list-item", children: A })
                  ]
                }
              )
            }
          )
        ]
      }
    );
  };
  return /* @__PURE__ */ a(xe.Provider, { value: He, children: /* @__PURE__ */ T(
    st,
    {
      ref: x,
      className: S(["DropdownBase__wrapper", X]),
      ...Ae,
      ...Be,
      children: [
        /* @__PURE__ */ a(
          it,
          {
            ref: g,
            "aria-disabled": u,
            onKeyUp: (e) => {
              !u && ce(e);
            },
            onKeyDown: (e) => {
              if (e.key === "ArrowUp" || e.key === "ArrowDown")
                return e == null || e.preventDefault(), e == null || e.stopPropagation(), !1;
            },
            onClick: (e) => {
              e == null || e.preventDefault(), !u && ee();
            },
            className: S(["DropdownBase__trigger-wrapper", { "DropdownBase__trigger-wrapper--disabled": u }]),
            id: `control-container-${_}`,
            children: p.current.controlElement || ie
          }
        ),
        I ? Je(de(), document.body) : de()
      ]
    }
  ) });
};
Y.Control = pt;
Y.Item = Ee;
Y.Divider = ae;
Y.Title = ut;
export {
  Y as D,
  Ee as a
};
